import './sticky';

import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';
import Companies from './components/Companies';
import DealerZones from './components/DealerZones';
import Holidays from './components/Holidays';
import States from './components/States';
import Users from './components/Users';
import ZipCodes from './components/ZipCodes';
import OrdersTable from './components/OrdersTable';
import OrderDetail from './components/OrderDetail';
import Report from './components/Report';

import ComponentHelpers from './ComponentHelpers';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/order/admin/orders', component: OrdersTable, name: 'orders-table'},
        {path: '/order/admin/orders/:id([0-9]+)', component: OrderDetail, name: 'order-detail', props: true },
    ],

    scrollBehavior(to, from, savedPosition) {
        if (to.name == 'order-detail') {
            return {x: 0, y: 0};
        } else if (to.meta.lastPosition) {
            return {x: 0, y: to.meta.lastPosition};
        }
    },
});

router.beforeEach((to, from, next) => {
    from.meta.lastPosition = window.scrollY;
    next();
});

Vue.mixin(ComponentHelpers);

const app = new Vue({
    el: 'main',
    store,
    router,
    components: {
        Companies,
        DealerZones,
        Holidays,
        OrderDetail,
        OrdersTable,
        Report,
        States,
        Users,
        ZipCodes,
    },
    data() {
        return {
            flashMessages: {},
        }
    },
    methods: {
        setFlashMessage(type, message)
        {
            this.flashMessages[type] = message;
        },
        getFlashMessage(type, clean=false)
        {
            if (this.flashMessages[type] != 'undefined') {
                var message = this.flashMessages[type];

                if (clean) {
                    this.setFlashMessage(type, '');
                }
                return message;
            }
            if (clean) {
                this.setFlashMessage(type, '');
            }
            return '';
        },
    },
    mounted() {
        if (this.$refs.autofocus) {
            this.$refs.autofocus.focus();
        }
    }
});
